export const environment = {
  config: 'config.json',
  production: true,
  appInsights: {
    instrumentationKey: '',
  },
};
